import { r as registerInstance, c as createEvent, f as forceUpdate, h, a as getElement } from './index-ih07wrgW.js';
import { T as TRANSACTION_STATES } from './createCase-9mS88qbx.js';
import { s as setEnv, b as getEnvConfig, c as getPublicApiClient } from './publicApiClient-C-YZFxlI.js';
import { i as i18nProvider, l as loadTranslations } from './loadTranslations-lQVeesvD.js';

const uploadMedia = async ({ callId, files, apiClient }) => {
    return Promise.all(files.map((file) => {
        return apiClient.request("/servicecall/uploadmedia", {
            headers: {
                CallId: callId,
                Accept: "application/json",
                "Content-Type": file.type,
                FileName: file.name
            },
            body: file,
            method: "POST",
            binary: true
        });
    }));
};

const sisConnectorCss = "";

const SisConnector = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.mfServiceCaseSuccess = createEvent(this, "mfServiceCaseSuccess");
        this.mfServiceCaseShowSuccess = createEvent(this, "mfServiceCaseShowSuccess");
        this.mfServiceCaseCancel = createEvent(this, "mfServiceCaseCancel");
        this.response = null;
        this.errorMessage = null;
        this.isRequestPending = false;
        this.locale = null;
        this.parent = null;
        this.apiClient = null;
        this.tbdbTokenReceived = false;
        this.onServiceCaseSubmit = async (event) => {
            if (!this.apiClient) {
                return;
            }
            this.isRequestPending = true;
            if (this.tbdbTokenReceived) {
                const { data, callId, files } = event.detail;
                this.apiClient
                    .request("/servicecall/createcase", { body: data })
                    .then((response) => {
                    this.response = response;
                })
                    .then(() => uploadMedia({
                    callId,
                    files,
                    apiClient: this.apiClient
                }).catch((error) => {
                    throw new Error("Case was created, but file upload failed: " + error.message);
                }))
                    .then(() => {
                    this.showSuccess();
                })
                    .catch((error) => {
                    this.errorMessage = error.message;
                })
                    .finally(() => {
                    this.isRequestPending = false;
                });
            }
            else {
                this.errorMessage = "TBDB token not received. Case could not be created.";
                this.isRequestPending = false;
            }
        };
    }
    showSuccess() {
        this.mfServiceCaseShowSuccess.emit();
    }
    onSuccess() {
        this.mfServiceCaseSuccess.emit();
    }
    onCancel() {
        this.mfServiceCaseCancel.emit();
    }
    connectedCallback() {
        var _a, _b, _c;
        this.i18nSubscriberId = i18nProvider.subscribe(() => forceUpdate(this));
        this.onLocaleChange();
        this.parent = this.host.closest("mf-create-service-case");
        (_a = this.parent) === null || _a === void 0 ? void 0 : _a.addEventListener("mfServiceCaseSubmit", this.onServiceCaseSubmit);
        this.locale = ((_b = this.parent) === null || _b === void 0 ? void 0 : _b.locale) || null;
        const parentEnv = (_c = this.host.closest("mf-create-service-case, mf-create-service-case-modal")) === null || _c === void 0 ? void 0 : _c.env;
        if (parentEnv) {
            setEnv(parentEnv);
        }
        this.config = getEnvConfig();
        this.apiClient = getPublicApiClient(this.config);
        this.unsubscribeToTbdbToken = this.apiClient.subscribeToTbdbToken((event) => {
            if (event.success) {
                this.tbdbTokenReceived = true;
            }
            else {
                this.errorMessage = event.errorMessage || "TBDB token request failed";
            }
        });
    }
    disconnectedCallback() {
        var _a;
        (_a = this.parent) === null || _a === void 0 ? void 0 : _a.removeEventListener("mfServiceCaseSubmit", this.onServiceCaseSubmit);
        i18nProvider.unsubscribe(this.i18nSubscriberId);
        if (this.unsubscribeToTbdbToken) {
            this.unsubscribeToTbdbToken();
        }
    }
    onLocaleChange() {
        if (this.locale !== i18nProvider.language) {
            this.loadTranslations();
        }
    }
    loadTranslations() {
        loadTranslations(this.locale).then((locale) => {
            i18nProvider.changeLanguage(locale);
            this.locale = locale;
        });
    }
    render() {
        var _a, _b;
        if (this.isRequestPending) {
            return h("ux-loader", { variant: "spinner" });
        }
        if (this.response === null && this.errorMessage === null) {
            return null;
        }
        const t = (key, options = undefined) => i18nProvider.t(`mf-service-calls:${String(key)}`, options);
        if (((_b = (_a = this.response) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.transactionState) === TRANSACTION_STATES.RECEIVED) {
            return (h("mf-create-service-case-success", { locale: this.locale, response: this.response, clickHandler: this.onSuccess, myTrumpfBaseUrl: this.config.myTrumpfBaseUrl }));
        }
        else {
            return (h("div", null, h("h1", { class: "ux-text-headline" }, t("sisConnector.failed.headline")), h("p", { class: "ux-text-normal" }, this.errorMessage || t("sisConnector.failed.unknownError")), h("ux-button", { type: "button", onClick: () => this.onCancel(), formnovalidate: true }, t("button.cancel"))));
        }
    }
    get host() { return getElement(this); }
    static get watchers() { return {
        "locale": ["onLocaleChange"]
    }; }
};
SisConnector.style = sisConnectorCss;

export { SisConnector as ux_f_sis_create_case_connector };
//# sourceMappingURL=ux-f-sis-create-case-connector.entry.js.map

//# sourceMappingURL=ux-f-sis-create-case-connector.entry.js.map